import { render, staticRenderFns } from "./editPageBlocks.vue?vue&type=template&id=0a421955&scoped=true&"
import script from "./editPageBlocks.vue?vue&type=script&lang=js&"
export * from "./editPageBlocks.vue?vue&type=script&lang=js&"
import style0 from "./editPageBlocks.vue?vue&type=style&index=0&id=0a421955&prod&scoped=true&lang=css&"
import style1 from "./editPageBlocks.vue?vue&type=style&index=1&id=0a421955&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a421955",
  null
  
)

export default component.exports